import { ability, ActionMap } from '@oliasoft/authorization-ui';
import { CaslEnums } from 'src/enums/casl-enums';
import { AccessTypes } from 'src/enums/access-control';

export const validatePriceBookAccess = (
  currentUserId: string,
  priceBookAccessData: any,
  priceBookSubjectId?: string | null,
): boolean => {
  const hasAdminAccess = ability.can(ActionMap.MANAGE, CaslEnums.Access);
  if (!priceBookAccessData?.accessRights) {
    return true;
  }
  const { metadata } = priceBookAccessData;
  const isPriceBookOwner = currentUserId === priceBookSubjectId;
  const isPublicAccess = metadata?.accesstype === AccessTypes.All;

  if (hasAdminAccess || isPriceBookOwner || isPublicAccess) {
    return true;
  }
  const isUserInAccessList = !!priceBookAccessData?.accessRights?.find((r: any) => r.subjectid === currentUserId);
  return isUserInAccessList;
};

export const hasRestrictedAccess = (priceBookAccessData: any): boolean => {
  const restrictedAccessTypes: AccessTypes[] = [AccessTypes.OnlyMe, AccessTypes.Selected];

  const hasRestrictedAccessType = restrictedAccessTypes.includes(
    priceBookAccessData.metadata?.accesstype as AccessTypes,
  );
  const hasAccessUsersList = Boolean(priceBookAccessData.accessRights?.length);

  return hasRestrictedAccessType || hasAccessUsersList;
};
